import React from "react";
import { hydrate, render } from "react-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// react-snap prerenders each route to static HTML at build time; when that
// HTML loads in a browser, hydrate over it instead of re-rendering from
// scratch. Plain render is the dev-server path (empty #root).
const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
  hydrate(app, rootElement);
} else {
  render(app, rootElement);
}
